"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var classNames = require("classnames");
var bg_image_1 = require("../../lib/bg_image");
var bind_1 = require("../../bind");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var TRACK_NAME = 'LPGridCard';
var LPGridCard = /** @class */ (function (_super) {
    tslib_1.__extends(LPGridCard, _super);
    function LPGridCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LPGridCard.prototype.hasNoInventory = function () {
        return this.props.inventory === 0;
    };
    LPGridCard.prototype.renderInventory = function () {
        return (React.createElement("div", { className: "grid-card__footer" },
            React.createElement("div", { className: "grid-card__footer__pricing" },
                React.createElement("div", { className: "grid-card__price" }, I18n.t('discovery.lpGridCard.price', {
                    price: this.props.fromPrice,
                    count: this.props.inventory,
                })))));
    };
    LPGridCard.prototype.trackName = function () {
        return this.props.trackName || TRACK_NAME;
    };
    LPGridCard.prototype.trackClick = function () {
        tracker_1.trackInteraction({
            componentName: this.trackName(),
            type: 'lp_album',
            url: this.props.url,
        });
    };
    LPGridCard.prototype.render = function () {
        var classes = classNames('grid-card', 'grid-card--lp', { 'grid-card--no-inventory': this.hasNoInventory() });
        return (React.createElement("div", { className: classes },
            React.createElement("a", { href: this.props.url, target: "_blank", onClick: this.trackClick, className: "grid-card__inner", rel: "noopener noreferrer" },
                React.createElement("div", { className: "grid-card__main" },
                    React.createElement("div", { className: "grid-card__image", style: bg_image_1.bgImage(this.props.image, !!this.props.image) }),
                    React.createElement("div", { className: "grid-card__main__text" },
                        React.createElement("div", { className: "grid-card__artist" }, this.props.artist),
                        React.createElement("div", { className: "grid-card__title" }, this.props.title))),
                this.renderInventory())));
    };
    tslib_1.__decorate([
        bind_1.default
    ], LPGridCard.prototype, "trackClick", null);
    return LPGridCard;
}(React.Component));
exports.default = LPGridCard;
//# sourceMappingURL=lp_grid_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/embeds/lp_grid_card.js
// module id = uuLM
// module chunks = 20 21